import {
  Button,
  CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
} from "@mui/material";
import { Delete, FileDownload } from "@mui/icons-material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {exportTransactions, exportTxnForBrowserDownload} from "../../actionCreators/export-transactions";
import { deleteTransactionResponse } from "../../api/api";
import {
  DATA_ENTRY,
  DELETE_TRANSACTION,
  EXPORT_TRANSACTION, SALES_PERSON_ROLE,
} from "../../utilities/constants";
import {avgSprdMrgPct, formatDate} from "../../utilities/utils";
import { isAuthorizedactivity } from "../Utility/isAuthorizedactivity";
import ToastUtility from "../Utility/toast-utility";
import {getUserObj, hasRole} from "../../utilities/tp-validations";

const TransactionSummary = (props) => {
  const [flags, setFlags] = useState({
    open: false,
    isExporting: false,
    deleteBtnClick: false,
  });
  const [toastObj, setToastObj] = useState({
    variant: "default",
    display: "none",
    message: "",
  });
  let toastTimeout;
  const dispatch = useDispatch();
  const { pageDetails } = props.searchTransactionResponse || {};
  const pageCount = pageDetails?.pageCount || 0;

  const handleSearchTransaction = async (searchObj) => {
    const updatedSearchObj = {
      ...searchObj,
    };
    if (searchObj.fromDate) {
      updatedSearchObj.fromDate = formatDate(searchObj.fromDate);
    }
    if (searchObj.toDate) {
      updatedSearchObj.toDate = formatDate(searchObj.toDate);
    }
    if(searchObj.avgSprdPct){
      updatedSearchObj.avgSprdPct = avgSprdMrgPct(searchObj.avgSprdPct)
    }
    try {
      await props.fetchSearchTransactions(updatedSearchObj);
      props.setTableVisibility(true);
    } catch (error) {
      console.error("handleSearchTransaction ", error);
    }
  };

  const handleDeleteWarning = () => {
    if (props.selectedTransactions.length !== 0) {
      setFlags((prevObj) => ({
        ...prevObj,
        open: true,
      }));
    } else {
      showToast("info", props.texts.PLZ_SLC_TRANS_FOR_DEL);
    }
  };
  const handleDeleteTransactions = () => {
    setFlags((prevObj) => ({
      ...prevObj,
      deleteBtnClick: true,
    }));
    try {
      if (props.selectedTransactions.length !== 0) {
        let filtered = props.selectedTransactions.filter(function (x) {
          return x !== undefined;
        });
        deleteTransactionResponse(
          filtered.toString(),
          props.isSimulateMode
        ).then((response) => {
          setFlags((prevObj) => ({
            ...prevObj,
            open: false,
            deleteBtnClick: false,
          }));
          props.resetSearchPageComponents("selectedTxns");
          if (response.txnStatus === "DELETED") {
            showToast("success", props.texts.TRANS_DEL_SUCCESS_MSG);
            handleSearchTransaction(props.searchObj);
          }
        });
      } else {
        showToast("info", props.texts.PLZ_SLC_TRANS_FOR_DEL);
        setFlags((prevObj) => ({
          ...prevObj,
          deleteBtnClick: false,
        }));
      }
    } catch (e) {
      setFlags((prevObj) => ({
        ...prevObj,
        deleteBtnClick: false,
      }));
    }
  };

  const showToast = (variant, message) => {
    clearTimeout(toastTimeout);
    setToastObj({
      variant,
      display: "inline",
      message,
    });

    toastTimeout = setTimeout(() => {
      setToastObj((prevToastObj) => ({
        ...prevToastObj,
        display: "none",
      }));
    }, 5000);
  };

  const handleButtonClick = async () => {
      setFlags((prevObj) => ({
        ...prevObj,
        isExporting: true,
      }));
    const userDetails = getUserObj(props);
      showToast("info", props.texts.GEN_TRAN_RPT_WAITING_MSG);
      const updatedSearchObj = {
        ...props.searchObj,
        email : props.userDetails.email,
        noOfTxn : pageCount
      };
    const isSalesPerson = hasRole(SALES_PERSON_ROLE, props);
    const isDataEntryUser = hasRole(DATA_ENTRY, props);
      if (props.searchObj.fromDate) {
        updatedSearchObj.fromDate = formatDate(props.searchObj.fromDate);
      }
      if (props.searchObj.toDate) {
        updatedSearchObj.toDate = formatDate(props.searchObj.toDate);
      }
      if (props.searchObj?.avgSprdPct) {
        updatedSearchObj.avgSprdPct = avgSprdMrgPct(props.searchObj.avgSprdPct)
      }
      if(isSalesPerson){
        updatedSearchObj.salePersonID = userDetails.userId;
      }
      if(isDataEntryUser){
        updatedSearchObj.createByUser = userDetails.userId;
      }
      try {
        // Added condition to browser download the export report which is below 5000 record.
        if(pageCount <= 5000){
          await dispatch(exportTxnForBrowserDownload(updatedSearchObj));
            showToast("success", props.texts.TRAN_EXP_SUCCESSFULLY_MSG);
        }else {
          await dispatch(exportTransactions(updatedSearchObj));
          setTimeout(() => {
            showToast("success", props.texts.TRAN_EXP_EMAIL_SUCCESSFULLY_MSG);
          }, 5000);
        }
      } catch (error) {
        if (error.status === 204) {
          showToast("info", props.texts.NO_TRANS_FOUND_MSG);
        } else {
          showToast("error", props.texts.FAIL_TO_EXPORT_TRAN_MSG);
        }
      } finally {
        setFlags((prevObj) => ({
          ...prevObj,
          isExporting: false,
        }));
      }
  };

  const authorizedActivities = props.isSimulateMode
    ? props.simulatedBusinessActivities
    : props.businessActivities;

  const buttonStyles = {
    float: "right",
    marginTop: "-15px",
    marginLeft: "10px",
  };

  return (
    <div style={{ margin: "10px" }}>
      {props.texts.TOTAL_TRANS}: {pageCount}
      {isAuthorizedactivity(
        EXPORT_TRANSACTION.activityId,
        authorizedActivities
      ) && (
        <Button
          variant="primary"
          style={{
            ...buttonStyles,
            ...{ backgroundColor: "#008C20", color: "#FFFFFF" },
          }}
          endIcon={<FileDownload />}
          onClick={handleButtonClick}
          disabled={flags.isExporting}
        >
          {props.texts.EXPORT}
        </Button>
      )}
      {isAuthorizedactivity(
        DELETE_TRANSACTION.activityId,
        authorizedActivities
      ) && (
        <Button
          variant="primary"
          style={{
            ...buttonStyles,
            ...{ color: "white", backgroundColor: "red" },
          }}
          onClick={handleDeleteWarning}
          endIcon={<Delete />}
        >
          {props.texts.DELETE_FUNC}
        </Button>
      )}
      <div>
        <Dialog
          open={flags.open}
          onClose={() =>
            setFlags((prevObj) => ({
              ...prevObj,
              open: false,
            }))
          }
          aria-labelledby="alert-Modal-title"
          aria-describedby="alert-Modal-description"
        >
          <DialogTitle id="alert-Modal-title">Alert</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-Modal-description">
              {props.texts.ARE_U_SURE_TO_DEL_TRAN}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClose={() =>
                setFlags((prevObj) => ({
                  ...prevObj,
                  open: false,
                }))
              }
              disabled={flags.deleteBtnClick}
              variant="secondary"
            >
              {props.texts.CANCEL}
            </Button>
            <Button
              style={{ color: "white", backgroundColor: "red" }}
              onClick={handleDeleteTransactions}
              variant="primary"
              disabled={flags.deleteBtnClick}
              endIcon={
                flags.deleteBtnClick && (
                  <CircularProgress
                    size="small"
                    style={{ color: "#000", marginLeft: "7px" }}
                  />
                )
              }
            >
              {props.texts.DELETE_FUNC}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <ToastUtility
        toastDisplay={toastObj.display}
        toastVariant={toastObj.variant}
        toastMessage={toastObj.message}
      />
    </div>
  );
};

export default TransactionSummary;
